// extracted by mini-css-extract-plugin
export var container = "about-us-item-module--container--gjv7p";
export var subTitle = "about-us-item-module--subTitle--W8HuA";
export var content = "about-us-item-module--content--Pb4nY";